import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification } from '../components/notifications/notification.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationCommunicationService {
  private notificationSelectedSource = new Subject<Notification>();
  notificationSelected$ = this.notificationSelectedSource.asObservable();

  private showListSource = new Subject<void>();
  showList$ = this.showListSource.asObservable();

  selectNotification(notification: Notification) {
    this.notificationSelectedSource.next(notification);
  }
  
  requestShowList() {
    this.showListSource.next();
  }
}
